import { gql } from "@apollo/client";

export const UPDATE_QUEUE_RECORD_MUTATION = gql`
  mutation UpdateQueueRecord($input: UpdateQueueRecordInput!) {
    updateQueueRecord(input: $input) {
      success
      error
    }
  }
`;
